import useCouponListQuery from "../../../api/coupon/useCouponListQuery"

const useCouponCount = () => {
  const { couponList } = useCouponListQuery()

  return couponList?.length ?? null
}

export default useCouponCount
